<template>
    <div class="betSlipContainer" data-testid="betslip-panel">
        <Message
            v-bind:show="!!betSlipMessage"
            position="top"
            padding="4px 13px"
            status="danger"
            data-testid="betslip-error"
            v-bind:message="betSlipMessage"
        />
        <div class="betSlip">
            <div class="ticketContainer">
                <DynamicMarketTicket v-bind:ticket="betSlip" />
            </div>
            <PlaceBetBlock />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import type { PropType } from 'vue';
    import { toRefs } from 'vue';
    import DynamicMarketTicket from '@/components/betSlip/DynamicMarketTicket.vue';
    import Message from '@/components/betSlip/Message.vue';
    import PlaceBetBlock from '@/components/betSlip/PlaceBetBlock.vue';
    import { BetSlipContext } from '@/components/betSlip/betSlipContext';
    import type { IDynamicMarketBetSlip } from '@/interface/IDynamicMarketBetSlip';

    const props = defineProps({
        betSlip: {
            type: Object as PropType<IDynamicMarketBetSlip>,
            required: true,
        },
    });

    const { betSlip } = toRefs(props);
    const { betSlipMessage } = BetSlipContext.provide(betSlip);
</script>

<style lang="scss" scoped>
    @import "@/components/betSlip/BetSlip";
</style>
